



















import { Component, Vue, Prop } from 'vue-property-decorator'
import { MediaComponentProps } from './VideoCallRoomContainer.vue'

@Component({
  components: {
    SubScreen: () => import('./VideoCallSubScreenGridItem.vue'),
    VideoCallAudio: () => import('./VideoCallAudio.vue')
  }
})
export default class VideoCallSubScreenGridList extends Vue {
  @Prop(Array) participants!: Array<MediaComponentProps>

  readonly MAX_SUB_SCREEN_NUMBER = 6

  handleSelectSubScreen(id: number) {
    this.$emit('changeMainScreen', id)
  }
}
